var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdaho(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.744,181.307l-0.338-4.553l-2.191-1.688l-4.375,1.135l-0.176,0.046c0,0,0,3.71-1.182,3.879 c-1.181,0.168-20.572-1.518-22.089-1.518s-6.071,1.854-6.071,1.854l-1.686-10.455l-8.093-7.924l-3.54-24.619l-9.783,6.24 l-3.876-4.891l9.442-28.496c0,0-6.342-5.393-8.093-7.532c-2.121-2.588-3.935-12.072-7.646-15.289 c-3.372-2.922-6.35-7.531-6.35-7.531l1.181-7.982l-4.892-9.048l6.24-29.509l-19.333-3.934c0,0-19.562,75.765-17.314,87.006 l-0.801-0.184l3.049,6.929l4.947,2.697v5.172L95.96,146.402l-1.574,5.621l-3.372,1.236c0,0-6.971,10.227-6.296,12.478 c0.675,2.247,3.823,0.899,3.823,0.899l1.35,3.147l-4.723,10.342L73.03,234.533c0,0,41.421,11.186,129.945,24.844l11.395-68.773 l0.71-4.288L211.744,181.307z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdaho);
export default __webpack_public_path__ + "static/media/idaho.df35a9a174bbeda31175fcb8483298f4.svg";
export { ForwardRef as ReactComponent };